import React from 'react';

type StatusBadgeProps = {
  status: string;
  size?: 'sm' | 'md';
};

const statusConfig: Record<string, { label: string; className: string }> = {
  published: { label: 'Published', className: 'badge-published' },
  draft: { label: 'Draft', className: 'badge-draft' },
  cancelled: { label: 'Cancelled', className: 'badge-cancelled' },
  completed: { label: 'Completed', className: 'badge-completed' },
  pending: { label: 'Pending', className: 'badge-pending' },
  suspended: { label: 'Suspended', className: 'badge-suspended' },
  active: { label: 'Active', className: 'badge-active' },
  confirmed: { label: 'Confirmed', className: 'badge-confirmed' },
  refunded: { label: 'Refunded', className: 'badge-refunded' },
  used: { label: 'Used', className: 'badge-completed' },
  general: { label: 'General', className: 'badge-draft' },
  vip: { label: 'VIP', className: 'badge-pending' },
};

export default function StatusBadge({ status, size = 'sm' }: StatusBadgeProps) {
  const config = statusConfig[status.toLowerCase()] ?? { label: status, className: 'badge-draft' };
  const sizeClass = size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-sm px-3 py-1';
  return (
    <span className={`inline-flex items-center font-semibold rounded-full ${sizeClass} ${config.className}`}>
      {config.label}
    </span>
  );
}